import React, { useState, useRef } from "react";
import axios, { CancelToken, isCancel } from "axios";
import { BsCloudUpload } from "react-icons/bs";
import style from "./classified.module.css";
import { useGetPreSignedUrlMutation } from "../../redux/api/uploadApi";
import {
  useAddClassifiedsCategoryMutation,
  useEditClassifiedCategoryMutation,
} from "../../redux/api/classifiedApi";

const AddClassified = ({ setAddClassified, classified, setClassified }) => {
  const [nameEn, setNameEn] = useState(
    classified._id ? classified.category_en : ""
  );
  const [nameAr, setNameAr] = useState(
    classified._id ? classified.category_ar : ""
  );
  const [imgsrc, setImagesrc] = useState(
    classified._id ? classified.image : ""
  );
  const [imgeFile, setImgeFile] = useState("");
  const [loading, setLoading] = useState(false);
  const filePikerRef = useRef(null);

  const [getPreSignedUrl] = useGetPreSignedUrlMutation();
  const [addClassifiedsCategory] = useAddClassifiedsCategoryMutation();
  const [editClassifiedCategory] = useEditClassifiedCategoryMutation();

  const filePickerHandeler = (event) => {
    if (event.target.files && event.target.files.length > 0) {
      setImgeFile(event.target.files[0]);
      const reader = new FileReader();
      reader.readAsDataURL(event.target.files[0]);
      reader.addEventListener("load", () => {
        setImagesrc(reader.result);
      });
    } else {
      alert("no file selected");
    }
  };

  const onSaveHandler = async () => {
    if (!nameEn) {
      alert("Category name EN is required");
      return;
    }
    if (!nameAr) {
      alert("Category name AR is required");
      return;
    }

    if (classified._id) {
      setLoading(true);

      if (!imgeFile && imgsrc) {
        editClassified(imgsrc);
      }
      if (imgeFile) {
        getPresignedUrl([imgeFile.name], imgeFile.type, imgeFile);
      }
    } else {
      if (!imgeFile) {
        alert("image is required");
        return;
      }
      setLoading(true);
      getPresignedUrl([imgeFile.name], imgeFile.type, imgeFile);
    }
  };

  const addClassifieds = async (fileurl) => {
    const res = await addClassifiedsCategory({
      category_en: nameEn,
      category_ar: nameAr,
      category_image: fileurl,
    });

    if (res.error) {
      if (res.error.status === 400) {
        alert(res.error.data.error);
      }
    }
    if (res.data) {
      setImagesrc("");
      setNameAr("");
      setNameEn("");
      setImgeFile("");
      setAddClassified(false);
      setClassified({ _id: "" });
    }
    setLoading(false);
  };

  const editClassified = async (fileurl) => {
    const res = await editClassifiedCategory({
      category_id: classified._id,
      category_en: nameEn,
      category_ar: nameAr,
      category_image: fileurl,
    });

    if (res.error) {
      if (res.error.status === 400) {
        alert(res.error.data.error);
      }
    }
    if (res.data) {
      setImagesrc("");
      setNameAr("");
      setNameEn("");
      setImgeFile("");
      setAddClassified(false);
      setClassified({ _id: "" });
    }
    setLoading(false);
  };

  const getPresignedUrl = async (fileNames, contentType, imgeFile) => {
    const res = await getPreSignedUrl({
      fileNames: fileNames,
      contentType: contentType,
      flocation: "posts",
    });

    if (res.error) {
      if (res.error.status === 400) {
        alert(res.error.data.error);
      }
      setLoading(false);
    }
    if (res.data) {
      await uploadFile(
        res.data.preSignedUrls[0].preSignedUrlToUplaodToAWS,
        res.data.preSignedUrls[0].pathNametoStoreInDBaftersucessfullupload,
        imgeFile
      );
    }
  };

  const uploadFile = async (prsignedURL, storeTODB, imgeFile) => {
    const options = {
      headers: {
        "Content-Type": "multipart/form-data",
      },
      onUploadProgress: (progressEvent) => {
        const { loaded, total } = progressEvent;

        let percent = Math.floor((loaded * 100) / total);
        console.log(percent);
      },
    };
    axios
      .put(prsignedURL, imgeFile, options)
      .then((res) => {
        if (classified._id) {
          editClassified(storeTODB);
        } else {
          addClassifieds(storeTODB);
        }
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  };

  return (
    <div>
      <div className={style.classifiedHeaderWrapper}>
        Add New Classified Category
      </div>
      <div className={style.addCategoryWrapper}>
        {loading && (
          <div>
            <span className="loader-spiner"></span>
            <span className="text-primary">...adding post</span>
          </div>
        )}
        <div className={style.imageWrapper}>
          <input
            type="file"
            ref={filePikerRef}
            accept="image/*"
            className="display-n"
            onChange={filePickerHandeler}
          />
          {imgsrc && (
            <div className="text-align-center">
              <img src={imgsrc} alt="catgeory" className={style.catImage} />
              <div
                className={style.uploadImgButton}
                onClick={() => {
                  if (loading) {
                    alert("please wait its uploading");
                  } else {
                    filePikerRef.current.click();
                  }
                }}
              >
                Change Image <BsCloudUpload />
              </div>
            </div>
          )}
          {!imgsrc && (
            <div
              className={style.uploadImgButton}
              onClick={() => {
                if (loading) {
                  alert("please wait its uploading");
                } else {
                  filePikerRef.current.click();
                }
              }}
            >
              Add Image <BsCloudUpload />
            </div>
          )}
        </div>
        <div className={style.nameTextsWrapper}>
          <div className={style.textLable}>Name(EN)</div>
          <div>
            <input
              value={nameEn}
              type="text"
              className={style.nameTexts}
              onChange={(e) => {
                setNameEn(e.target.value);
              }}
              disabled={loading ? true : false}
            />
          </div>
        </div>
        <div className={style.nameTextsWrapper}>
          <div className={style.textLable}>Name(AR)</div>
          <div>
            <input
              type="text"
              value={nameAr}
              className={style.nameTexts}
              onChange={(e) => {
                setNameAr(e.target.value);
              }}
              disabled={loading ? true : false}
            />
          </div>
        </div>

        <div className={style.buttonWrapper}>
          <button className="btn btn-success" onClick={onSaveHandler}>
            Save
          </button>
          <button
            className="btn btn-danger"
            onClick={() => {
              setAddClassified(false);
              setClassified({ _id: "" });
            }}
          >
            Back
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddClassified;
